import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchBusinessData } from "../api/code";

// Async thunk for fetching business data
export const getBusinessData = createAsyncThunk(
  "business/fetchBusinessData",
  async (_, thunkAPI) => {
    try {
      const response = await fetchBusinessData();
      return response.data;
    } catch (error) {
      console.error("Error fetching business data:", error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  data: {}, // Default to an empty object
  loading: false,
  error: null,
};

// Business slice
const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    resetBusinessData: (state) => {
      state.data = {};
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBusinessData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBusinessData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBusinessData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetBusinessData } = businessSlice.actions;
export const businessDataReducer = businessSlice.reducer;
